import {StyleSheet} from 'react-native'

export const flatten = StyleSheet.flatten
